(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function initPageToc(section) {
    const content = section.querySelector('[data-page-content]');
    const tocWrap = section.querySelector('[data-page-toc]');
    const tocList = section.querySelector('[data-page-toc-list]');
    if (!content || !tocWrap || !tocList) return;

    tocList.innerHTML = '';

    const headings = content.querySelectorAll('h2');
    if (headings.length === 0) {
      tocWrap.hidden = true;
      return;
    }

    tocWrap.hidden = false;

    headings.forEach((heading, index) => {
      const text = heading.textContent.trim();
      if (!text) return;

      let id = heading.id;
      if (!id) {
        id = slugify(text) || `section-${index + 1}`;
        let uniqueId = id;
        let counter = 2;
        while (document.getElementById(uniqueId)) {
          uniqueId = `${id}-${counter}`;
          counter += 1;
        }
        heading.id = uniqueId;
        id = uniqueId;
      }

      const link = document.createElement('a');
      link.href = `#${id}`;
      link.className = 'main-page__toc-link';
      link.textContent = text;
      tocList.appendChild(link);
    });

    if (tocList.children.length === 0) {
      tocWrap.hidden = true;
    }
  }

  function initMainPage(root) {
    const section = root.matches('[data-main-page]') ? root : root.querySelector('[data-main-page]');
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';
    initPageToc(section);
  }

  function initAll() {
    document.querySelectorAll('[data-main-page]').forEach(initMainPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-main-page]');
    if (section) {
      section.dataset.initialized = 'false';
      initMainPage(section);
    }
  });
})();
